module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"head":{"meta":{"description":"TODO:このページの説明文をここに記述する(※Googleの検索結果に表示されるのでよく考える事!)"}},"date_of_event":"date","deadl.info-tableine":"Deadl.info-tableine","time_zone":"Time","location":"Location","details":"Details","holding_method":"Holding Method","venue":{"type_face_to_face":"Locally","type_remote":"WEB","type_both":"Locally＋WEB"},"head_office":"Head office"}}')
  delete Component.options._Ctor
}
